module.exports = "<p>raise-claim works!</p>\n"